import { Card, Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import type { IMapMarker } from '@sravni/react-shared-components/dist/types/YandexMap/types/interface';
import { YandexMap } from '@sravni/react-shared-components/lib/YandexMap';
import { useMemo, useState } from 'react';

import { mapMarker } from '../../assets';

import styles from './Map.module.scss';

interface IShowYandexMap {
  coordinates: Array<{
    latitude: number;
    longitude: number;
    description: {
      workTime?: string;
      address?: string;
    };
    uin: string | number;
  }>;
  center: [number, number] | undefined;
}

type TDetails = {
  workTime?: string;
  address?: string;
} | null;

type TExtendedMapMarker = IMapMarker & {
  description: {
    workTime?: string;
    address?: string;
  };
};

export const Map = ({ coordinates, center }: IShowYandexMap) => {
  const [details, setDetails] = useState<TDetails>(null);

  const markers = useMemo(() => {
    if (!coordinates.length) {
      return [];
    }
    return coordinates.map(({ latitude, longitude, uin, description }) => ({
      id: uin,
      latitude,
      longitude,
      hint: '',
      balloonSrc: mapMarker as string,
      description,
    }));
  }, [coordinates]);

  const onSelectItem = (item: IMapMarker | null) => {
    if (!item) {
      setDetails(null);
      return;
    }

    setDetails({
      workTime: (item as TExtendedMapMarker)?.description?.workTime,
      address: (item as TExtendedMapMarker)?.description?.address,
    });
  };

  return (
    <div className={styles.wrapper}>
      <YandexMap
        markers={markers}
        center={center}
        zoom={12}
        onSelectItem={onSelectItem}
      />
      {details && (
        <Card className={styles.detailsCard}>
          <Space
            direction="vertical"
            size={16}
          >
            <Heading level={5}>{details?.address}</Heading>
            <Space
              size={4}
              direction="vertical"
            >
              <Text className="h-color-D60">График работы</Text>
              <Text>{details?.workTime}</Text>
            </Space>
          </Space>
        </Card>
      )}
    </div>
  );
};
